'use strict';
angular.module('schoolLinqApp').directive('lessThanOrEqual', [
	function () {
		var link = function ($scope, $element, $attrs, ctrl) {
			var validate = function (viewValue) {
				var comparisonModel = $attrs.lessThanOrEqual;

				if (!viewValue && !comparisonModel) {
					ctrl.$setValidity('lessThanOrEqual', true);
				} else {
					// It's valid if model is lower than the model we're comparing against
					ctrl.$setValidity('lessThanOrEqual', parseInt(viewValue, 10) <= parseInt(comparisonModel, 10));
				}

				return viewValue;
			};

			ctrl.$parsers.unshift(validate);
			ctrl.$formatters.push(validate);

			$attrs.$observe('lessThanOrEqual', function (comparisonModel) {
				// Whenever the comparison model changes we'll re-validate
				return validate(ctrl.$viewValue);
			});
		};

		return {
			require: 'ngModel',
			link: link,
		};
	},
]);
